import Actions from '../../odata/actions';

const actions = new Actions('hubSpotCompany', 'hubSpotCompanies');

export default actions;
